import React from 'react';
import bent from 'bent';
import { useParams, useHistory } from 'react-router-dom';
import { Connect } from "aws-amplify-react";
import { graphqlOperation } from "aws-amplify";
import * as queries from './graphql/queries';

const Scheduled = () => {
    const { room_id } = useParams();
    const history = useHistory();
    return <Connect query={graphqlOperation(queries.getRoom, {id:room_id})} >
        {({loading, error, data}) => {
            if (loading) return <>loading...</>
            if (error) return <>error</>

            if (data && data.getRoom) {
                console.log(
                    data.getRoom.scheduled,
                    Date.parse(data.getRoom.scheduled),
                    Date.now()/1000
                )
                if (data.getRoom.scheduled > (Date.now()/1000) ) {                
                    return <>
                        <h2>Interview has not yet started.</h2>
                        <strong>
                            You may share the invite link ahead of time:
                            <pre>https://{process.env.REACT_APP_API_DOMAIN}/guest/{room_id}</pre>
                        </strong>
                    </>
                }                
                else {              
                    const roomCall = bent(`https://${process.env.REACT_APP_API_DOMAIN}/`, 'POST', 'json', 200);
                    roomCall('room/startScheduled', {room_id}).then(() => {
                        history.push(`/rooms/${room_id}`);
                    })                    
                }
            }
            else {
                return <>error</>
            }
        }}
    </Connect>
}

export default Scheduled;